export const setBgColorAttendanceStatus = status => {
  switch (status) {
    case "Present":
      return "#C7E2D0";
    case "Ex.absence":
      return "#F4E4FD";
    case "Unex.absence":
      return "#F3D7D5";
    case "Ex.tardy":
      return "#DEE8F5";
    case "Unex.tardy":
      return "#FCDDB1";
    case "unchecked":
      return "#C6C6C6";
    default:
      return "";
  }
};
export const setColorAttendanceStatus = status => {
  switch (status) {
    case "Present":
      return "#08980E";
    case "Ex.absence":
      return "#964AA0";
    case "Unex.absence":
      return "#D6030C";
    case "Ex.tardy":
      return "#2D82B5";
    case "Unex.tardy":
      return "#D3660A";
    case "unchecked":
      return "#111111";
    default:
      return "";
  }
};
